import { setTimeout } from '@/utils/global';

export default {
  mounted(el, binding, vNode) {
    setTimeout(() => {
      if (vNode?.componentInstance?.$options?.name === 'OgSelect') {
        vNode.componentInstance.openDropdown();
      } else {
        el.focus();
      }
    });
  },
};
